import React from "react";
import { CURRENT_YEAR } from "./AdminConstants";
import { CollapsibleSection, FormField } from "./AdminShared";

function FunctionDetailsTab({ config, setConfig }) {
  const details = config.function_details;

  const updateDetail = (key, value) => {
    setConfig((prev) => ({
      ...prev,
      function_details: { ...prev.function_details, [key]: value }
    }));
  };

  const updateDateRange = (field, value) => {
    setConfig((prev) => {
      const currentRange = prev.function_details.daterange || {};
      const updated = { ...currentRange, [field]: value };

      // Auto-generate display string when start or end changes
      if (field === "start" || field === "end") {
        const startDate = field === "start" ? value : updated.start;
        const endDate = field === "end" ? value : updated.end;
        if (startDate && endDate) {
          const fmt = (d) =>
            new Date(d + "T00:00:00").toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric"
            });
          updated.display = `${fmt(startDate)} – ${fmt(endDate)}`;
        }
      }

      return {
        ...prev,
        function_details: { ...prev.function_details, daterange: updated }
      };
    });
  };

  const daterange = details.daterange || {};

  return (
    <div className="admin-tab-content">
      <CollapsibleSection
        title="Basic Information"
        subtitle="Core function identity and display settings"
      >
        <div className="admin-form-grid">
          <FormField label="Function ID" hint="Read-only">
            <input
              className="admin-input admin-input--disabled"
              value={config.function_id}
              disabled
            />
          </FormField>
          <FormField label="Name" required>
            <input
              className="admin-input"
              value={details.name}
              onChange={(e) => updateDetail("name", e.target.value)}
              placeholder="e.g., VRMO"
            />
          </FormField>
          <FormField label="Display Label" required>
            <input
              className="admin-input"
              value={details.label}
              onChange={(e) => updateDetail("label", e.target.value)}
              placeholder="e.g., VRMO-Ops-WBR"
            />
          </FormField>
          <FormField label="Full Name" required>
            <input
              className="admin-input"
              value={details.full_name}
              onChange={(e) => updateDetail("full_name", e.target.value)}
            />
          </FormField>
          <FormField label="Start Year">
            <input
              className="admin-input"
              type="number"
              min={2015}
              max={CURRENT_YEAR}
              value={details.start_year}
              onChange={(e) => updateDetail("start_year", Number(e.target.value))}
            />
          </FormField>
          <FormField label="Meeting Link" hint="URL for the recurring meeting">
            <input
              className="admin-input"
              type="url"
              value={details.meeting_link || ""}
              onChange={(e) => updateDetail("meeting_link", e.target.value)}
              placeholder="https://chime.aws/1234567890"
            />
          </FormField>
          <FormField label="Function Team" hint="Team email or distribution list">
            <input
              className="admin-input"
              type="email"
              value={details.function_team || ""}
              onChange={(e) => updateDetail("function_team", e.target.value)}
              placeholder="e.g., team-name@amazon.com"
            />
          </FormField>
        </div>
      </CollapsibleSection>

      <CollapsibleSection
        title="Week & Date Range"
        subtitle="Current week number and reporting date range"
      >
        <div className="admin-form-grid">
          <FormField label="Week" required hint="WBR week number">
            <input
              className="admin-input"
              type="number"
              min={1}
              max={53}
              value={details.week || ""}
              onChange={(e) => updateDetail("week", Number(e.target.value))}
              placeholder="e.g., 15"
            />
          </FormField>
          <FormField label="Date Range – Start" required>
            <input
              className="admin-input"
              type="date"
              value={daterange.start || ""}
              onChange={(e) => updateDateRange("start", e.target.value)}
            />
          </FormField>
          <FormField label="Date Range – End" required>
            <input
              className="admin-input"
              type="date"
              value={daterange.end || ""}
              onChange={(e) => updateDateRange("end", e.target.value)}
            />
          </FormField>
          <FormField
            label="Display Text"
            hint="Auto-generated from dates, or override manually"
          >
            <input
              className="admin-input"
              value={daterange.display || ""}
              onChange={(e) => updateDateRange("display", e.target.value)}
              placeholder="e.g., Apr 05, 2026 – Apr 11, 2026"
            />
          </FormField>
        </div>
      </CollapsibleSection>
    </div>
  );
}

export default FunctionDetailsTab;
